import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import Modal from './'

import womanNotebook from '../../svg/womanNotebook.svg'

class Upgrade extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {}
        this.base_state = this.state
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    async componentDidMount() {
        this._isMounted = true
    }

    onExited = evt => {
        this.setState({})
    }

    render() {
        const { is_open, overlay_close, settings, events, necessary_features = null, t } = this.props

        return (
            <Modal
                settings={{ overlay_close: overlay_close }}
                data={{ open: is_open, max_width: settings.max_width }}
                events={{ onCloseModal: events.on_close }}
            >
                <div className="modal-variant--1 p1">
                    <div className="main">
                        <div className="title">{t('_components._modal._upgrade.title')}</div>
                        <div className="icon">
                            <img src={womanNotebook} alt="" />
                        </div>
                        {Array.isArray(necessary_features)
                            ? necessary_features.map(({ tariff, description }) => {
                                  return (
                                      <div className="text" key={description}>
                                          <p>{`${description} ${t(
                                              '_components._modal._upgrade.text_2',
                                          )} ${tariff}.`}</p>
                                      </div>
                                  )
                              })
                            : null}
                        {/* <div className="text">
                            <p>{t('_components._modal._upgrade.text_1')}</p>
                        </div> */}
                        <div className="buttons">
                            <button
                                className="button"
                                data-size="lg"
                                data-variant="secondary"
                                onClick={events.on_close}
                            >
                                {t('_components._modal._upgrade.next_time')}
                            </button>
                            <button
                                className="button"
                                data-size="lg"
                                data-variant="primary"
                                onClick={events.init_action(
                                    'save-redirect',
                                    '/account/billing-and-payments?tab=subscription',
                                )}
                            >
                                {t('_common.upgrade')}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default compose(connect(null, null), withTranslation('translations'))(Upgrade)
